import React from 'react'
import PaiementTable from '../../components/PaiementTable/PaiementTable'
import Icon from '../../components/Icon/Icon'
import "./Admin.scss"

const Paiements = () => {
    return (
        <div className='container-main'>
            <div className="content-header">
                <div className="header-left">
                    <Icon alias="payment" width={24} height={24} color="#1a1a1a" />
                    <h2>Payments</h2>
                </div>
                <p className="header-subtitle">View and manage payment transactions</p>
            </div>
            <PaiementTable />
        </div>
    )
}

export default Paiements